import Text from 'components/shared/Text'

import { ServerErrorModalWrapper } from './styles'

import { FormattedMessage, useIntl } from 'react-intl'
import ModalInfo from 'components/shared/ModalInfo'
import { useAppSelector } from 'store/hooks'

interface ServerErrorModalProps {
    onClick: () => void
    isLoading?: boolean
}

const ServerErrorModal = ({ onClick, isLoading }: ServerErrorModalProps) => {
    const { formatMessage } = useIntl()
    const { isErrorModalOpened } = useAppSelector((state) => state.general)

    return (
        <ModalInfo
            isOpened={isErrorModalOpened}
            variant="primary"
            buttonLabel={formatMessage({
                id: 'global.btn.try_again',
                defaultMessage: 'Spróbuj ponownie',
            })}
            onButtonClick={() => onClick()}
            width={490}
            isLoading={isLoading}
            testIdPrefix="general-error-modal"
        >
            <ServerErrorModalWrapper gap={16}>
                <Text variant="heading3" color="grayscale_900">
                    <FormattedMessage
                        id="global.server_error_modal.title"
                        defaultMessage="Przepraszamy, coś poszło nie tak."
                    />
                </Text>
                <Text variant="body" color="grayscale_900">
                    <FormattedMessage
                        id="global.server_error_modal.body_text"
                        defaultMessage="Niestety pojawił się niespodziewany błąd, za który przepraszamy. Jeżeli wystąpi on ponownie, spróbuj ponownie za parę minut."
                    />
                </Text>
            </ServerErrorModalWrapper>
        </ModalInfo>
    )
}

export default ServerErrorModal
